import script from "./LogoProject.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogoProject.vue?vue&type=script&lang=ts&setup=true"

import "./LogoProject.vue?vue&type=style&index=0&id=d771361c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d771361c"]])

export default __exports__